import { useLogout } from "@fideus/auth";
import { LoadingPage } from "@fideus-ui/core";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useMutation, useTRPC } from "../_app/api";

export const Route = createFileRoute("/abmelden")({
  component: LogoutRoute,
});

function LogoutRoute() {
  const logout = useLogout();
  const trpc = useTRPC();
  const { mutateAsync: serverLogout } = useMutation(
    trpc.logout.mutationOptions()
  );

  useEffect(() => {
    void serverLogout().finally(() => logout());
  }, [serverLogout, logout]);

  return <LoadingPage loadingText="Abmeldung läuft..." />;
}
